import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import {
  collection,
  getDocs
} from "firebase/firestore";

import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  CircularProgress,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button
} from "@mui/material";


import Navbar from "../../Components/Navbar/navbar";
import { db } from "../../Config/firebase";
import { consultaTenantAtual } from "../../Utils/tenant";
import RelatorioOcorrenciasPrint from "./RelatorioOcorrenciasPrint";


export default function ListaOcorrencias() {
  const history = useHistory();

  const [ocorrencias, setOcorrencias] = useState([]);
  const [loading, setLoading] = useState(true);
  const [statusFiltro, setStatusFiltro] = useState("TODOS");
  const [tipoFiltro, setTipoFiltro] = useState("TODOS");
  const [exibirRelatorio, setExibirRelatorio] = useState(false);

  function normalizarClassificacaoNC(valor) {
    return String(valor || "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .trim()
      .replace(/\s+/g, "_")
      .toUpperCase();
  }



  /* =========================
     CARREGAR OCORRÊNCIAS
  ========================= */
  useEffect(() => {
    async function carregar() {
      setLoading(true);

      const snap = await getDocs(
        consultaTenantAtual(collection(db, "kpi_eventos"))
      );

      setOcorrencias(
        snap.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        })).sort((a, b) =>
          (b.criadoEm?.toMillis?.() || 0) - (a.criadoEm?.toMillis?.() || 0)
        )
      );

      setLoading(false);
    }

    carregar();
  }, []);

  /* =========================
     STATUS → CHIP
  ========================= */
  function renderStatus(status) {
    if (status === "Encerrada")
      return <Chip label="Encerrada" color="success" size="small" />;

    if (status === "Em andamento")
      return <Chip label="Em andamento" color="warning" size="small" />;

    return <Chip label="Aberta" color="error" size="small" />;
  }

  /* =========================
     TIPO → CHIP
  ========================= */
        function renderTipo(oc) {
        if (oc.tipoRegistro === "MELHORIA")
          return <Chip label="Melhoria" color="info" size="small" />;

        if (oc.tipoRegistro === "OCORRENCIA")
          return <Chip label="Ocorrência" size="small" />;

        if (oc.tipoRegistro === "INSPECAO_AMBIENTES")
          return <Chip label="Inspeção de Ambientes" color="primary" size="small" />;

        if (oc.tipoRegistro === "NC") {
          if (oc.classificacaoNC === "AUDITORIA_INTERNA")
            return <Chip label="NC • Auditoria Interna" color="warning" size="small" />;

          if (oc.classificacaoNC === "AUDITORIA_EXTERNA")
            return <Chip label="NC • Auditoria Externa" color="secondary" size="small" />;

          return <Chip label="NC • Dia a dia" color="error" size="small" />;
        }

        return "-";
      }


  const ocorrenciasFiltradas = ocorrencias.filter(oc => {
  // 🔹 FILTRO STATUS
  const passaStatus =
    statusFiltro === "TODOS" || oc.status === statusFiltro;

  // 🔹 FILTRO TIPO
  let passaTipo = true;
  const classificacaoNC = normalizarClassificacaoNC(oc.classificacaoNC);

  if (tipoFiltro === "NC_DIA_A_DIA") {
    passaTipo =
      oc.tipoRegistro === "NC" &&
      (!classificacaoNC || classificacaoNC === "DIA_A_DIA");
  }

  if (tipoFiltro === "NC_AUDITORIA_INTERNA") {
    passaTipo =
      oc.tipoRegistro === "NC" &&
      classificacaoNC === "AUDITORIA_INTERNA";
  }

  if (tipoFiltro === "NC_AUDITORIA_EXTERNA") {
    passaTipo =
      oc.tipoRegistro === "NC" &&
      classificacaoNC === "AUDITORIA_EXTERNA";
  }

  if (tipoFiltro === "MELHORIA") {
    passaTipo = oc.tipoRegistro === "MELHORIA";
  }

  if (tipoFiltro === "OCORRENCIA") {
    passaTipo = oc.tipoRegistro === "OCORRENCIA";
  }

  if (tipoFiltro === "INSPECAO_AMBIENTES") {
    passaTipo = oc.tipoRegistro === "INSPECAO_AMBIENTES";
  }

  return passaStatus && passaTipo;
});

  const rotulosTipo = {
    TODOS: "Todos",
    NC_DIA_A_DIA: "NC • Dia a dia",
    NC_AUDITORIA_INTERNA: "NC • Auditoria Interna",
    NC_AUDITORIA_EXTERNA: "NC • Auditoria Externa",
    MELHORIA: "Melhoria",
    OCORRENCIA: "Ocorrência",
    INSPECAO_AMBIENTES: "Inspeção de Ambientes",
  };

  if (exibirRelatorio) {
    return (
      <RelatorioOcorrenciasPrint
        registros={ocorrenciasFiltradas}
        filtros={{ tipo: rotulosTipo[tipoFiltro], status: statusFiltro === "TODOS" ? "Todos" : statusFiltro }}
        onVoltar={() => setExibirRelatorio(false)}
      />
    );
  }


  return (
    <>
      <Navbar />

      <div className="container-fluid mt-4 px-4">

        <h4>Não Conformidades e Melhorias Registradas (RQ 1.3)</h4>
          <Box
              mb={2}
              display="flex"
              justifyContent="flex-end"
              gap={2}
            >
               <Box
                    mb={2}
                    display="flex"
                    justifyContent="flex-end"
                    gap={2}
                  >
                    {/* 🔹 FILTRO TIPO */}
                    <FormControl size="small" sx={{ minWidth: 220 }}>
                      <InputLabel>Tipo</InputLabel>
                      <Select
                        label="Tipo"
                        value={tipoFiltro}
                        onChange={(e) => setTipoFiltro(e.target.value)}
                      >
                        <MenuItem value="TODOS">Todos</MenuItem>

                        <MenuItem value="NC_DIA_A_DIA">NC • Dia a dia</MenuItem>
                        <MenuItem value="NC_AUDITORIA_INTERNA">NC • Auditoria Interna</MenuItem>
                        <MenuItem value="NC_AUDITORIA_EXTERNA">NC • Auditoria Externa</MenuItem>

                        <MenuItem value="MELHORIA">Melhoria</MenuItem>
                        <MenuItem value="OCORRENCIA">Ocorrência</MenuItem>
                        <MenuItem value="INSPECAO_AMBIENTES">Inspeção de Ambientes</MenuItem>
                      </Select>
                    </FormControl>

                    {/* 🔹 FILTRO STATUS */}
                    <FormControl size="small" sx={{ minWidth: 200 }}>
                      <InputLabel>Status</InputLabel>
                      <Select
                        label="Status"
                        value={statusFiltro}
                        onChange={(e) => setStatusFiltro(e.target.value)}
                      >
                        <MenuItem value="TODOS">Todos</MenuItem>
                        <MenuItem value="Aberta">Aberta</MenuItem>
                        <MenuItem value="Em andamento">Em andamento</MenuItem>
                        <MenuItem value="Encerrada">Encerrada</MenuItem>
                      </Select>
                    </FormControl>

                    <Button
                      variant="contained"
                      onClick={() => setExibirRelatorio(true)}
                      disabled={loading || ocorrenciasFiltradas.length === 0}
                    >
                      Gerar relatório
                    </Button>
                  </Box>

            

          </Box>



        {loading && (
          <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 1.5, py: 4 }}>
            <CircularProgress />
            <Typography color="text.secondary">Carregando registros...</Typography>
          </Box>
        )}

        {!loading && (
          <TableContainer component={Paper} className="mt-3">
            <Table size="small" sx={{ tableLayout: "auto" }}>


              <TableHead>
                  <TableRow>
                    <TableCell sx={{ width: 140 }}><b>Relator</b></TableCell>
                    <TableCell sx={{ width: 90 }}><b>Data</b></TableCell>

                    {/* 🔥 RELATO – PRIORIDADE */}
                    <TableCell sx={{ width: "45%" }}><b>Relato</b></TableCell>

                    <TableCell sx={{ width: 160 }}><b>Referência</b></TableCell>
                    <TableCell sx={{ width: 70, textAlign: "center" }}><b>Anexo</b></TableCell>
                    <TableCell sx={{ width: 110 }}><b>Classificação</b></TableCell>
                    <TableCell sx={{ width: 90 }}><b>Prazo</b></TableCell>
                    <TableCell sx={{ width: 150 }}><b>Tipo</b></TableCell>
                    <TableCell sx={{ width: 120 }}><b>Status</b></TableCell>
                  </TableRow>
                </TableHead>


              <TableBody>
                {ocorrenciasFiltradas.map(oc => (
                  <TableRow
                    key={oc.id}
                    hover
                    style={{ cursor: "pointer" }}
                    onClick={() => history.push(`/ocorrencias/${oc.id}`)}
                  >
                    <TableCell sx={{ maxWidth: 140, whiteSpace: "normal" }}>
                          {oc.userNome}
                        </TableCell>
                        


                    <TableCell>
                      {oc.criadoEm?.toDate
                        ? oc.criadoEm.toDate().toLocaleDateString()
                        : "-"}
                    </TableCell>

                    <TableCell style={{ maxWidth: 250 }}>
                      {oc.descricao}
                    </TableCell>

                     <TableCell>
                            {oc.referencia || "-"}
                          </TableCell>


                    <TableCell>
                      {oc.imagemUrl && (
                        <a
                          href={oc.imagemUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          onClick={e => e.stopPropagation()}
                        >
                          📎
                        </a>
                      )}
                    </TableCell>

                    <TableCell>{oc.classificacao || "-"}</TableCell>

                    <TableCell>
                      {oc.prazo
                         ? (() => {
                          const [ano, mes, dia] = oc.prazo.split("-");
                          return `${dia}/${mes}/${ano}`;
                          })()
                        : "-"}

                    </TableCell>

                    <TableCell>{renderTipo(oc)}</TableCell>


                    <TableCell>{renderStatus(oc.status)}</TableCell>
                  </TableRow>
                ))}

                {ocorrenciasFiltradas.length === 0 && (
                    <TableRow>
                      <TableCell colSpan={9} align="center">
                        Nenhuma ocorrência para o status selecionado
                      </TableCell>
                    </TableRow>
                  )}

              </TableBody>
            </Table>
          </TableContainer>
        )}
      </div>
    </>
  );
}
